import { createApp } from 'vue';
import FeaturesNavigation from './index.vue';
import './index.scss';

const navigation = createApp(FeaturesNavigation);

navigation.mount(document.getElementById('vue-features-navigation'));